<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 23C18.0228 23 22.5 18.5228 22.5 13C22.5 7.47715 18.0228 3 12.5 3C6.97715 3 2.5 7.47715 2.5 13C2.5 18.5228 6.97715 23 12.5 23ZM13.1668 6.97412C10.1465 6.97412 7.69802 9.42256 7.69802 12.4429C7.69802 12.5996 7.70464 12.755 7.71764 12.9088C7.78884 13.7511 7.24342 14.9487 6.73758 15.6344C6.56074 15.8741 6.55183 16.2296 6.76528 16.4373L9.13315 18.742C9.34275 18.9461 9.69103 18.9329 9.93232 18.7676C10.6267 18.2918 11.8553 17.8205 12.7009 17.892C12.8546 17.905 13.01 17.9116 13.1668 17.9116C16.1871 17.9116 18.6355 15.4632 18.6355 12.4429C18.6355 11.8917 18.5537 11.3582 18.4011 10.8546C18.3215 10.5918 18.1097 10.3901 17.8434 10.3234C17.577 10.2566 17.2952 10.3346 17.101 10.5288L13.644 13.9858C13.1486 13.9215 12.6711 13.6993 12.2907 13.3189C11.9104 12.9385 11.6882 12.461 11.6239 11.9656L15.0809 8.50863C15.275 8.31447 15.353 8.03264 15.2863 7.76629C15.2195 7.49994 15.0178 7.28819 14.755 7.20855C14.2515 7.05591 13.718 6.97412 13.1668 6.97412Z" 
                :fill="color"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgWrench',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>